import { useAdminUserAttributesQuery } from '../generated/graphql'
import { useActiveAuctionId } from '../activeAuctionIdStore'
import { pickUserAttributes } from '../utils/pickUserAttributes'

/** Uses Apollo Context through `useAdminUserAttributesQuery` */
export const useAdminUserAttributes = (props?: { userId?: string }) => {
    const auctionId = useActiveAuctionId()
    const { data } = useAdminUserAttributesQuery({
        variables: { userId: props?.userId || '', auctionId },
        skip: !props?.userId,
    })

    return pickUserAttributes(data?.administrator?.user?.attributes)
}
